<template>
  <div class="card-edit card-theme card-edit-new-theme project-view"  :key="refreshDetail" v-on="dirtyListeners">
    <card-edit-subheader v-if="cardLoaded" type="projectView" :hideActions="true"/>
    <div class="edit-body has-background-grey-lighter">
      <div class="" v-if="cardLoaded">
        <div class="column primary-card-info">
          <div class="columns">
            <div class="column is-flex">
              <i class="has-text-white image is-48x48 is-inline-block"
              :class="getDynamicClasses"> </i>
              <div class="has-text-dark is-flex is-justify-content-flex-end">
                <span>{{ project.name }}</span>
              </div>
            </div>
            <div class="column is-2 px-0">
              <div class="has-text-dark">
                 <label class="has-text-black-bis is-italic is-size-3 label">Status</label>
                <span>{{ project.status }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="column secondary-card-info">
          <div class="columns is-multiline">
            <div class="column is-2">
              <div class="field is-flex is-justify-content-space-between">
                <span class="has-text-black-bis is-italic is-size-2 has-text-weight-semibold">
                  Project Owner:
                </span>
                <span class="is-size-3">
                  {{ $_.get(project, 'projectOwner.name', '') }}
                </span>
              </div>
            </div>
            <div class="column"></div>
            <div class="column">
              <div class="field is-flex is-justify-content-space-between">
                <span class="has-text-black-bis is-italic is-size-2 has-text-weight-semibold">
                  Project ID:
                </span>
                <span class="is-size-3">
                  {{ $_.get(currentCompProjSettings, 'customId', '') }}
                </span>
              </div>
            </div>
             <div class="column">
              <div class="field is-flex is-justify-content-space-between">
                <span class="has-text-black-bis is-italic is-size-2 has-text-weight-semibold">
                  Project Inventory Location: 
                </span>
                <span class="is-size-3">
                  {{ $_.get(currentCompProjSettings, 'projectInventoryLocation.name', '') }}
                </span>
              </div>
            </div>
            <div class="column has-text-dark  is-2">
                 <span class="has-text-black-bis is-italic is-size-3 has-text-weight-semibold">Created At: </span>
                <field-date
                  class="is-pulled-right"
                  :inputProps="{ kind: 'createdAt', disableEdit: true }"
                  :isEdit="false"
                  :rowData="project"
                  :rowField="{ prop: 'createdAt' }"/>
            </div>
            <div class="column has-text-dark  is-2">
              <div>
                 <span class="has-text-black-bis is-italic is-size-3 has-text-weight-semibold">Updated At: </span>
                <field-date
                  class="is-pulled-right"
                  :inputProps="{ kind: 'updatedAt', disableEdit: true }"
                  :isEdit="false"
                  :rowData="project"
                  :rowField="{ prop: 'updatedAt' }"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-edit-item-table has-background-grey-lighter">
        <mf-detail-row v-if="cardLoaded"
          :rowData="project"
          :refreshCard="loadCard"
          @tabName="setTabName"
          @saveCard="saveCard"
          :tabLabel="selectedTabName"
          @refreshCardViewOnKey="refreshDetail++"
          >
        </mf-detail-row>
      </div>
    </div>
    <o-loading :active="isLoading" />
  </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, computed } from 'vue'
import { find, isEmpty, set } from 'lodash';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';

// Below are local file imports
import CardEditMixin from '@/components/mixins/CardEditMixin';
import MfDetailRow from '@/components/table-fields/MfDetailRow.vue';
import CardEditSubHeader from '@/components/card-edit/CardEditSubheader.vue';

import Projects from '@/models/Projects';

export default {
  name: 'shipping-card-view',
  components: {
    'card-edit-subheader': CardEditSubHeader,
    'mf-detail-row': MfDetailRow,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    cardId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { onInitDirty } = CardEditMixin();
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const userData = store.state.userData;

    const data = reactive({
      project: {},
      isLoading: false,
      cardLoaded: false,
      selectedTabName: route.query.tab || 'details',
      currentCompProjSettings: {},
      refreshDetail: 0,
    });

    onInitDirty(data);

    const loadCard = async () => {
      try {
        data.isLoading = true;
        onInitDirty(data);
        data.project = await Projects.getOne(props.id);
      } catch(e) {
        console.log('Error: ', e);
      } finally {
        data.isLoading = false;
      }
    }

    const getDynamicClasses = computed(() => {
      const routeMeta = router.currentRoute.value.meta;
      let classes = '';
      if (routeMeta.activeViewColor) {
        classes = `${routeMeta.activeViewColor} `;
      }
      if (routeMeta.cardEditIcon) {
        classes += `icon-${routeMeta.cardEditIcon}`;
      }
      return classes;
    });

    const setTabName = (val) => {
      data.selectedTabName = val;
    };

    const saveCard = () => {}

    onBeforeMount(async () => {
      await loadCard();
      if (!isEmpty(data.project)) {
        const res = find(data.project.projectSettings, { companyId: userData.company._id || userData.company })
        if (!isEmpty(res)) data.currentCompProjSettings = res
        
      }
      data.cardLoaded = true;
    });

    const discardChanges = async (params) => {
      await loadCard();
      if (params && params.id) data.isDeliveryItemsRow = _.find(data.card.partialShipments, (partial) => partial._id === params.id)
      data.refreshKey++;
    }


    return {
      ...toRefs(data),
      getDynamicClasses,
      setTabName,
      saveCard,
      loadCard,
      discardChanges,
    }
  }
}
</script>

<style>

</style>